import { createSelector } from 'reselect';
import { resolveProp } from '@clearscore/helpers.resolve-props';

const windowPathname = () => (window && window.location ? window.location.pathname : undefined);
const currentPath = (state) => resolveProp('router.location.pathname', state) || windowPathname();

export default createSelector(currentPath, (path) => path);
